//820 notes: unused variable removed
// import { set } from '@/utils/vuex';

export default {
  setShopLanguage: (state, payload) => (state.general.dashboardLanguage = payload),
  setShopName: (state, payload) => (state.general.shopName = payload),
  setCustomCss: (state, payload) => (state.general.customCss = payload),
  setShopOwnerName: (state, payload) => (state.general.shopOwnerName = payload),
  setReviewRequestEmail: (state, payload) => (state.general.reviewRequestEmail = payload),
  setFromEmail: (state, payload) => (state.general.fromEmail = payload),
  setNotificationEmail: (state, payload) => (state.general.notificationEmail = payload),
  setShowQAndA: (state, payload) => (state.general.qAndAActive = payload),
  setReviewPublishing: (state, payload) => (state.reviews.reviewPublishing = payload),
  setImportsAutomaticSync: (state, payload) =>
    (state.reviewImporting.importsAutomaticSync = payload),
  setAutoReplaceObfuscatedReviewerNames: (state, payload) =>
    (state.reviewImporting.autoReplaceObfuscatedReviewerNames = payload),
  setImportedReviewAutoApprove: (state, payload) =>
    (state.reviewImporting.importedReviewAutoApprove = payload),
  setImporterProfiles: (state, payload) => (state.reviewImporting.importerProfiles = payload),
  setReportsFrequency: (state, payload) => (state.other.reportsFrequency = payload),
  setSendReviewRequestsOmnisend: (state, payload) =>
    (state.reviewRequests.sendReviewRequestsOmnisend = payload),
  setAdvancedReviewRequestsEmailTemplateActive: (state, payload) =>
    (state.reviewRequests.advancedReviewRequestsEmailTemplateActive = payload),
  setAdvancedCouponEmailTemplateActive: (state, payload) =>
    (state.reviewRequests.advancedCouponEmailTemplateActive = payload),
  setAdvancedUnverifiedReviewTemplateActive: (state, payload) =>
    (state.reviewRequests.advancedUnverifiedReviewTemplateActive = payload),
  setAdvancedPhotoRequestsEmailTemplateActive: (state, payload) =>
    (state.reviewRequests.advancedPhotoRequestsEmailTemplateActive = payload),
  setSendReviewRequests: (state, payload) => (state.reviewRequests.sendReviewRequests = payload),
  setRequestSequenceAdvancedView: (state, payload) =>
    (state.reviewRequests.requestSequenceAdvancedView = payload),
  setSendReviewRequestsKlaviyo: (state, payload) =>
    (state.reviewRequests.sendReviewRequestsKlaviyo = payload),
  setSendPhotoRequests: (state, payload) => (state.reviewRequests.sendPhotoRequests = payload),
  setSendPhotoRequestWaitDays: (state, payload) =>
    (state.reviewRequests.sendPhotoRequestWaitDays = payload),
  setPhotoRequestStarSubset: (state, payload) =>
    (state.reviewRequests.photoRequestStarSubset = payload),
  setDontSendToRepeatCustomers: (state, payload) =>
    (state.reviewRequests.dontSendToRepeatCustomers = payload),
  setPostPurchaseEmailDays: (state, payload) =>
    (state.reviewRequests.postPurchaseEmailDays = payload),
  setPostPurchaseEmailDaysInternational: (state, payload) =>
    (state.reviewRequests.postPurchaseEmailDaysInternational = payload),
  setPostPurchaseEmailDaysPosOrder: (state, payload) =>
    (state.reviewRequests.postPurchaseEmailDaysPosOrder = payload),
  setResendReviewRequests: (state, payload) =>
    (state.reviewRequests.resendReviewRequests = payload),
  setResendEmailWaitDays: (state, payload) => (state.reviewRequests.resendEmailWaitDays = payload),
  setPostPurchaseEmailSendAtHour: (state, payload) =>
    (state.reviewRequests.postPurchaseEmailSendAtHour = payload),
  setPostPurchaseEmailSendAtMinute: (state, payload) =>
    (state.reviewRequests.postPurchaseEmailSendAtMinute = payload),
  setBlacklistedReviewRequestEmails: (state, payload) =>
    (state.reviewRequests.blacklistedReviewRequestEmails = payload),
  setEmailDomain: (state, payload) => (state.reviewRequests.emailDomain = payload),
  setEmailSubdomain: (state, payload) => (state.reviewRequests.emailSubdomain = payload),
  setEmailRecords: (state, payload) => (state.reviewRequests.emailRecords = payload),
  setEmailStarsColor: (state, payload) => (state.reviewRequests.requestFormStarsColor = payload),
  setEmailLogo: (state, payload) => (state.reviewRequests.requestFormImageUrl = payload),
  setEmailCss: (state, payload) => (state.reviewRequests.requestFormCustomCss = payload),
  setShowReviewsFromArchivedProducts: (state, payload) =>
    (state.general.showReviewsFromArchivedProducts = payload),
  setDeactivateEmailNotifications: (state, payload) =>
    (state.general.deactivateEmailNotifications = payload),
  setEmailTranslationEnabled: (state, payload) => (state.general.emailTranslationEnabled = payload),
  setLogoUrl: (state, payload) => (state.general.logoUrl = payload),
  loadSettingsSuccess: (state, payload) => {
    Object.assign(state, payload);
  },
  updateSettingsSuccess: (state, payload) => {
    Object.assign(state, payload);
  },
  updateDashboardVersionSuccess: (state, payload) => {
    Object.assign(state, payload);
  },
  setSendOnlyReviewRequestsSms: (state, payload) =>
    (state.reviewRequests.sendOnlyReviewRequestsSms = payload),
  setReviewRequestExcludedProducts: (state, payload) =>
    (state.reviewRequests.reviewRequestExcludedProducts = payload),
};
